import moment from 'moment';

const shortDate = (date) => {
  return moment.utc(date).format('MM/DD/YYYY');
};

const shortDtm = (date) => {
  return moment(date).format('MM/DD/YYYY hh:mm:ss');
};

const getDate = () => {
  return moment().format('MM/DD/YYYY');
};

const getDateTime = () => {
  return moment().format('MM/DD/YYYY_hh:mm:ss');
};

const isDate = (str) => {
  // check the date and format
  // "1234-12" is not a valid date but the moment with ISO_8601 will return true as "1234/12/01"
  return (
    isNaN(str) &&
    isDateValid(str) &&
    moment(str, moment.ISO_8601, true).isValid()
  );
};

const isDateValid = (val) => {
  return moment(val, moment.ISO_8601, true).isValid();
};
const datePickerToShortDate = (date) =>
  date !== 'null' ? shortDate(new Date(date).toUTCString()) : '';

const toDate = (date) => {
  let newDate = new Date(date);
  return newDate;
};

const diffMinutes = (dt2, dt1) => {
  let diff = Math.floor(Math.abs(dt2 - dt1) / 1000 / 60);
  // console.log(dt2, dt1, diff);
  return diff;
};

const getDaysArray = (s, e) => {
  // adding one extra day at range end to include last day's data in MongoDB
  e.setDate(e.getDate() + 1);
  for (
    var a = [], d = new Date(s);
    d <= new Date(e);
    d.setDate(d.getDate() + 1)
  ) {
    a.push(new Date(d));
  }
  return a;
};

const getDateFromDtm = (d) => {
  let dtm = new Date(d);
  return dtm.getMonth() + 1 + '/' + dtm.getDate() + '/' + dtm.getFullYear();
};

const addDateWithYears = (date, years) => {
  const yearsToAdd = Math.floor(years);
  const decimalPart = years - yearsToAdd;
  const daysToAdd = Math.round(decimalPart * 365);
  const nextDate = new Date(date);
  nextDate.setFullYear(nextDate.getFullYear() + yearsToAdd);
  nextDate.setDate(nextDate.getDate() + daysToAdd);

  return nextDate;
};

// Converts a UTC date to the equivalent local date
const convertUTCDateToLocal = (date) => {
  if (!date) return null;
  const utcDate = new Date(date);

  return new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000 * -1);
};

/**
 * Parses a short date string into a local calendar date object.
 *
 * This function takes a short date string (e.g., "MM/DD/YYYY") and converts it into a JavaScript Date object that represents the equivalent local calendar date. It handles various input formats and ensures that the resulting date is normalized to the local timezone.
 *
 * @param {string} shortDate - The short date string to be parsed (e.g., "MM/DD/YYYY")
 */
export function parseToLocalCalendarDate(shortDate) {
  if (!shortDate) {
    return null;
  }

  const normalizeToLocalDate = (dateObj) =>
    new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());

  const parseDateLike = (value) => {
    if (Array.isArray(value)) {
      const [firstValue] = value;
      return parseDateLike(firstValue);
    }

    if (value instanceof Date) {
      return value;
    }

    if (typeof value === 'string') {
      const trimmedDate = value.trim();
      const match = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        const [, year, month, day] = match;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }

      return new Date(trimmedDate);
    }

    return new Date(value);
  };

  const parsedDate = parseDateLike(shortDate);
  if (isNaN(parsedDate.getTime())) {
    return null;
  }

  return normalizeToLocalDate(parsedDate);
}

export {
  shortDate,
  shortDtm,
  isDate,
  getDate,
  datePickerToShortDate,
  toDate,
  diffMinutes,
  getDaysArray,
  getDateFromDtm,
  isDateValid,
  getDateTime,
  addDateWithYears,
  convertUTCDateToLocal,
};
